export interface ClientConfig {
  Id: string;
  ClientId?: string;
  Identifier: string;
  FeatureId: string;
  Fields: any;
}

export interface Config {
  Id: string;
  Identifier: string;
  FeatureId: string;
  Fields: any;
  ClientConfig?: ClientConfig;
}

export class Identifiers {
  static PortalCache = '';
  static FrontendLogger = 'frontend.logger';
  static PortalTrafficDataPush = '';
  static TourGuide = '';
  // public static ReportingCustomerLifecycle = 'reporting_customerlifecycle';
}
export interface BdServiceableProvider {
  provider: string;
  message: string;
  warning: string;
  addons: string[];
  isMandatory: boolean;
}